import { render, staticRenderFns } from "./FormFieldsLabel.vue?vue&type=template&id=1116537f&scoped=true&"
import script from "./FormFieldsLabel.vue?vue&type=script&lang=js&"
export * from "./FormFieldsLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldsLabel.vue?vue&type=style&index=0&id=1116537f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1116537f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
